"use client"

import { useEffect } from "react"
import posthog from "posthog-js"
import { errorBoundaryCaptureProperties } from "@/lib/observability/posthog-scrub"
import { ErrorFallbackContent } from "@/components/error-fallback-content"

export default function RootSegmentError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // PostHog error tracking. A no-op where posthog-js never initialized (the
    // private messaging routes, an opted-out internal device); outside
    // production the before_send in instrumentation-client.ts drops it.
    posthog.captureException(error, errorBoundaryCaptureProperties(error.digest, document))
  }, [error])

  return <ErrorFallbackContent reset={reset} digest={error.digest} />
}
